export default __webpack_public_path__ + "static/media/Healthcare-hover.83dd5878.svg";